import { render, staticRenderFns } from "./rYmqc.vue?vue&type=template&id=15d3972c&scoped=true&"
import script from "./rYmqc.vue?vue&type=script&lang=js&"
export * from "./rYmqc.vue?vue&type=script&lang=js&"
import style0 from "./rYmqc.vue?vue&type=style&index=0&id=15d3972c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d3972c",
  null
  
)

export default component.exports